import React from 'react';
import ReactDOM from 'react-dom';
import CustomInspectorMUI from '../../../CustomInspector';

/**
 * Renderer for the DestinationField in the JointJS inspector
 *
 * @param {Object} field - The inspector field configuration
 * @param {joint.dia.Cell} cell - The JointJS cell instance
 * @param {joint.dia.Graph} graph - The JointJS graph instance
 * @param {joint.dia.Paper} paper - The JointJS paper instance
 * @param {Object} inspectorService - Service object for managing inspector state
 * @param {Object} theme - MUI theme for consistent styling
 */
export function renderDestinationField(field, cell, graph, paper, inspectorService, theme) {
  const container = document.createElement('div');

  const DestinationFieldComponent = () => {
    return (
      <CustomInspectorMUI
        graph={graph}
        paper={paper}
        cell={cell}
        inspectorService={inspectorService}
        onInspectorChange={() => {
          if (typeof field.onChange === 'function' && !field.readOnly) {
            field.onChange(cell);
          }
        }}
        MenuProps={{ disablePortal: true }}
        readOnly={field.readOnly}
      />
    );
  };

  ReactDOM.render(<DestinationFieldComponent />, container);
  return container;
}
